export default __webpack_public_path__ + "static/simple-pie-540497dbe63447fafee01cdf43495e09.png";